import React from 'react';
import cx from 'classnames';
import mask from './image/mask.png.js';
import mask2 from './image/mask-2.png.js';
import styles from '../Modal/index.module.scss.js';

const Panel = ({
  wins,
  wagered,
  bets,
  text = {
    wins: "Total Wins",
    bets: "Total Bets",
    wagered: "Total Wagered"
  },
  className,
  style
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.panels, className), style }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.panel) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-title"]) }, text.wins), /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-value"]) }, wins), /* @__PURE__ */ React.createElement("img", { className: cx(styles.mask), src: mask, alt: "" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles.panel) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-title"]) }, text.bets), /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-value"]) }, bets), /* @__PURE__ */ React.createElement("img", { className: cx(styles.mask), src: mask, alt: "" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles.panel) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-title"]) }, text.wagered), wagered?.currency ? /* @__PURE__ */ React.createElement("div", { className: cx(styles["panel-value"]) }, wagered.currency, wagered.amount) : null, /* @__PURE__ */ React.createElement("img", { className: cx(styles.mask), src: mask2, alt: "" })));
Panel.displayName = "UserInfoModal.Panel";

export { Panel };
//# sourceMappingURL=index.js.map
